/* ============================================================
   NZSupps — Find Your Stack quiz engine.
   Vanilla JS, no dependencies. Reads two JSON blobs in the page:
     #nzsq-config   — questions + result map + copy (editable in the section .liquid)
     #nzsq-products — live product data keyed by handle (Liquid-rendered from the pool collection)
   Renders a step quiz, scores answers to a curated stack, adds to cart.
   Cards support flavour + size selectors (custom.fys_flavours), per-serve/servings,
   a subscribe delivery-frequency slider, and a tested chip. Progress persists in a 7-day cookie.
   ============================================================ */
(function () {
  'use strict';

  var cfgEl = document.getElementById('nzsq-config');
  var prodEl = document.getElementById('nzsq-products');
  var app = document.getElementById('nzsq-app');
  if (!cfgEl || !prodEl || !app) return;

  var CONFIG, PRODUCTS;
  try {
    CONFIG = JSON.parse(cfgEl.textContent);
    PRODUCTS = JSON.parse(prodEl.textContent);
  } catch (e) { console.error('[NZSupps quiz] config parse failed', e); return; }

  var stage = app.querySelector('[data-nzsq-stage]');
  var bar = app.querySelector('[data-nzsq-progress]');
  var backBtn = app.querySelector('[data-nzsq-back]');
  var closeBtn = app.querySelector('[data-nzsq-close]');
  var questions = CONFIG.questions || [];
  var TPL = {
    question: document.getElementById('nzsq-question-tpl'),
    option: document.getElementById('nzsq-option-tpl'),
    card: document.getElementById('nzsq-result-card-tpl')
  };
  var state = { step: 0, answers: {}, lastFocus: null };
  var CARDS = [];            /* per-result-card state (handle, art, flavours, sel, entry) */
  var currentMode = 'onetime';
  var selectedWeek = 6;      /* subscribe delivery cadence (weeks) */
  var freqEl = null;         /* the frequency slider wrapper (toggled with mode) */
  var COOKIE = 'nzsq_progress';
  var CONFIG_VERSION = configVersion(CONFIG);

  function configVersion(config) {
    var source = JSON.stringify(config), hash = 0;
    for (var i = 0; i < source.length; i++) { hash = ((hash << 5) - hash + source.charCodeAt(i)) | 0; }
    return source.length + '-' + (hash >>> 0).toString(36);
  }

  /* ---- cookies (7-day progress) ---- */
  function setCookie(name, val, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }
  function delCookie(name) { document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'; }
  function saveProgress() { try { setCookie(COOKIE, JSON.stringify({ v: CONFIG_VERSION, step: state.step, answers: state.answers }), 7); } catch (e) {} }
  function loadProgress() { try { var raw = getCookie(COOKIE); if (!raw) return null; var o = JSON.parse(raw); if (o && o.v === CONFIG_VERSION && o.answers) return o; if (o && o.v !== CONFIG_VERSION) delCookie(COOKIE); } catch (e) {} return null; }

  /* ---- open / close ---- */
  function open(seedGoal) {
    state.lastFocus = document.activeElement;
    state.step = 0; state.answers = {};
    if (seedGoal && (CONFIG.resultMap || {})[seedGoal]) { state.answers.goal = seedGoal; state.step = 1; }
    else { var p = loadProgress(); if (p) { state.answers = p.answers || {}; state.step = Math.min(p.step || 0, questions.length); } }
    app.hidden = false;
    document.documentElement.classList.add('nzsq-lock');
    saveProgress();
    if (!seedGoal && p && state.step > 0) renderResumeChoice(); else render();
  }
  function close() {
    app.hidden = true;
    document.documentElement.classList.remove('nzsq-lock');
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
  }
  function renderResumeChoice() {
    backBtn.hidden = true;
    setProgress(state.step, questions.length + 1);
    stage.textContent = '';
    var root = document.createElement('div'); root.className = 'nzsq-q';
    var title = document.createElement('h2'); title.className = 'nzsq-q__title'; title.textContent = 'Pick up where you left off?';
    var hint = document.createElement('p'); hint.className = 'nzsq-q__hint'; hint.textContent = 'Your previous answers are saved.';
    var actions = document.createElement('div'); actions.className = 'nzsq-result__cta';
    var resumeBtn = btn('primary', 'Resume where you left off');
    var restartBtn = btn('ghost', 'Start over');
    resumeBtn.addEventListener('click', function () { render(); });
    restartBtn.addEventListener('click', function () { delCookie(COOKIE); state.step = 0; state.answers = {}; render(false); });
    actions.appendChild(resumeBtn); actions.appendChild(restartBtn);
    root.appendChild(title); root.appendChild(hint); root.appendChild(actions); stage.appendChild(root);
    stage.scrollTop = 0; resumeBtn.focus();
  }

  /* ---- nav ---- */
  function advance() { state.step++; render(); }
  function back() { if (state.step > 0) { state.step--; render(); } }
  function setProgress(done, total) { if (bar) bar.style.width = Math.min(Math.round(done / total * 100), 100) + '%'; }

  function render(persistProgress) {
    backBtn.hidden = state.step === 0;
    if (state.step < questions.length) { setProgress(state.step, questions.length + 1); renderQuestion(questions[state.step]); }
    else { setProgress(questions.length + 1, questions.length + 1); renderResults(); }
    if (persistProgress !== false) saveProgress();
    stage.scrollTop = 0;
    var f = stage.querySelector('button, input, a, select'); if (f) f.focus();
  }

  /* ---- question ---- */
  function renderQuestion(q) {
    stage.textContent = '';
    var node = TPL.question.content.cloneNode(true);
    node.querySelector('[data-count]').textContent = 'Question ' + (state.step + 1) + ' of ' + questions.length;
    node.querySelector('[data-title]').textContent = q.title;
    var hintEl = node.querySelector('[data-hint]'); if (hintEl) hintEl.textContent = q.hint || '';
    var wrap = node.querySelector('[data-options]');
    var multi = q.type === 'multi';
    var chosen = multi ? (state.answers[q.id] || []) : state.answers[q.id];

    q.options.forEach(function (opt) {
      var o = TPL.option.content.cloneNode(true);
      var btn = o.querySelector('.nzsq-option');
      o.querySelector('[data-label]').textContent = opt.label;
      var dEl = o.querySelector('[data-desc]'); if (dEl) dEl.textContent = opt.desc || '';
      var sel = multi ? chosen.indexOf(opt.id) !== -1 : chosen === opt.id;
      if (sel) btn.setAttribute('aria-pressed', 'true');
      btn.addEventListener('click', function () {
        if (multi) { toggleMulti(q, opt.id, wrap); }
        else {
          state.answers[q.id] = opt.id;
          wrap.querySelectorAll('.nzsq-option').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          setTimeout(advance, 200);
        }
      });
      wrap.appendChild(o);
    });

    if (multi) {
      var foot = node.querySelector('[data-foot]');
      var cont = document.createElement('button');
      cont.type = 'button'; cont.className = 'nzsq-btn nzsq-btn--primary';
      cont.textContent = q.cta || 'Continue';
      cont.addEventListener('click', function () {
        if (!state.answers[q.id]) state.answers[q.id] = [];
        advance();
      });
      foot.appendChild(cont);
    }
    stage.appendChild(node);
  }
  function toggleMulti(q, id, wrap) {
    var EXCL = ['none', 'any'];
    var arr = state.answers[q.id] || [];
    if (EXCL.indexOf(id) !== -1) arr = [id];
    else { arr = arr.filter(function (x) { return EXCL.indexOf(x) === -1; }); var i = arr.indexOf(id); if (i !== -1) arr.splice(i, 1); else arr.push(id); }
    state.answers[q.id] = arr;
    var opts = wrap.querySelectorAll('.nzsq-option');
    q.options.forEach(function (opt, idx) { if (opts[idx]) opts[idx].setAttribute('aria-pressed', arr.indexOf(opt.id) !== -1 ? 'true' : 'false'); });
    saveProgress();
  }

  /* ---- scoring ---- */
  function answerHas(qid, val) { var a = state.answers[qid]; return Array.isArray(a) ? a.indexOf(val) !== -1 : a === val; }
  function resolveSwap(base, swaps) {
    if (!swaps) return base;
    for (var i = 0; i < swaps.length; i++) {
      var s = swaps[i], ans = state.answers[s.q], hit = false;
      if (Array.isArray(ans)) { for (var j = 0; j < s.in.length; j++) { if (ans.indexOf(s.in[j]) !== -1) { hit = true; break; } } }
      else hit = s.in.indexOf(ans) !== -1;
      if (hit && PRODUCTS[s.use]) return s.use;
    }
    return base;
  }
  /* NZS-SPD-0808: can this handle actually be bought? The product is live from Liquid; a family
     card also counts as buyable when any snapshot sibling claims stock (the card then live-checks
     that sibling before it can be added). */
  function buyable(h) {
    var p = PRODUCTS[h];
    if (!p) return false;
    if (p.available !== false) return true;
    var fl = Array.isArray(p.flavours) ? p.flavours : [];
    for (var i = 0; i < fl.length; i++) if (fl[i].available !== false) return true;
    return false;
  }
  /* Resolve the answer-driven swap first (unchanged), then keep walking the SAME swap list for a
     buyable alternative before giving up — so a sold-out pick is swapped, not shown dead. */
  function resolveAvailable(base, swaps) {
    var h = resolveSwap(base, swaps);
    if (buyable(h)) return h;
    if (swaps) for (var i = 0; i < swaps.length; i++) if (buyable(swaps[i].use)) return swaps[i].use;
    return buyable(base) ? base : null;
  }
  function score() {
    var goal = state.answers.goal, map = (CONFIG.resultMap || {})[goal];
    if (!map) return null;
    var heroH = resolveAvailable(map.hero, map.heroSwaps);
    var supH = map.support ? resolveAvailable(map.support, map.supportSwaps) : null;
    var addH = map.addon ? resolveAvailable(map.addon, map.addonSwaps) : null;
    if (supH === heroH) supH = null;
    if (addH === heroH || addH === supH) addH = null;
    return {
      goal: goal,
      hero: PRODUCTS[heroH] ? heroH : null,
      support: supH && PRODUCTS[supH] ? supH : null,
      addon: addH && PRODUCTS[addH] ? addH : null
    };
  }

  /* ---- flavour / size helpers (mirror Build Your Stack) ---- */
  function parseServ(v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; }
  function pretty(s) { return String(s || '').split('-').map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join(' '); }
  function flavLabel(fl) { if (!fl) return 'Standard'; return pretty(fl); }
  function sizeLabel(sz) { return sz ? pretty(sz) : 'One size'; }
  function familyName(title) { return String(title || '').split(' - ')[0]; }
  function isAccessory(p) { return /shaker|accessor|bottle/i.test((p && p.type) || ''); }
  function fmtCents(c) { c = Number(c); if (isNaN(c)) return ''; return '$' + (c / 100).toFixed(2); }
  function serveLine(priceCents, servings) {
    var s = parseInt(servings, 10); if (!s || s <= 0) return '';
    var per = Math.round(Number(priceCents) / s); if (!per || isNaN(per)) return '';
    return fmtCents(per) + '/serve <i>&middot;</i> ' + s + ' serves';
  }
  function entryByVid(flavours, vid) { for (var i = 0; i < flavours.length; i++) if (String(flavours[i].vid) === String(vid)) return flavours[i]; return null; }
  /* NZS-SPD-0808: the snapshot entry for the card's OWN product. p.id is the VARIANT id; p.pid is
     the PRODUCT id (added to the rendered blob by nzs-quiz-funnel.liquid) and is matched too,
     because snapshot `vid`s go stale whenever a variant is recreated. */
  function selfEntry(flavours, p) {
    var e = entryByVid(flavours, p.id);
    if (e) return e;
    if (p.pid == null) return null;
    for (var i = 0; i < flavours.length; i++) if (String(flavours[i].id) === String(p.pid)) return flavours[i];
    return null;
  }
  /* NZS-SPD-0808: live truth for a flavour SIBLING, keyed by its own handle (never the base's).
     Snapshots carry no `handle` until scripts\regen_snapshots.py runs, and a missing handle must
     be a no-op that leaves today's behaviour intact rather than an error or a wrong fetch. */
  var LIVE = {}, LIVE_REQ = {};
  function liveResolve(handle, cb) {
    if (!handle) return;
    if (LIVE[handle]) { cb(LIVE[handle]); return; }
    if (LIVE_REQ[handle]) return;
    LIVE_REQ[handle] = 1;
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (pj) {
        var v = (pj.variants || [])[0] || {};
        LIVE[handle] = { price: v.price, compare_at_price: v.compare_at_price || 0,
                         available: v.available !== false, vid: v.id };
        cb(LIVE[handle]);
      })
      .catch(function () { /* 404 / offline: keep the snapshot value, never block the card */ });
  }
  function firstAvail(arr) { for (var i = 0; i < arr.length; i++) if (arr[i].available !== false) return arr[i]; return null; }
  function defaultEntry(flavours, baseVid) { return entryByVid(flavours, baseVid) || firstAvail(flavours) || flavours[0]; }
  function uniq(arr) { var o = [], seen = {}; arr.forEach(function (x) { var k = String(x); if (!seen[k]) { seen[k] = 1; o.push(x); } }); return o; }
  function distinctSizes(flavours) { return uniq(flavours.map(function (f) { return f.size || ''; })); }
  function flavoursForSize(flavours, size) { return uniq(flavours.filter(function (f) { return (f.size || '') === (size || ''); }).map(function (f) { return f.flavour || ''; })); }
  function sizesForFlavour(flavours, flavour) { return uniq(flavours.filter(function (f) { return (f.flavour || '') === (flavour || ''); }).map(function (f) { return f.size || ''; })); }
  function pickEntry(flavours, flavour, size) {
    var i;
    for (i = 0; i < flavours.length; i++) { if ((flavours[i].flavour || '') === (flavour || '') && (flavours[i].size || '') === (size || '')) return flavours[i]; }
    for (i = 0; i < flavours.length; i++) { if ((flavours[i].flavour || '') === (flavour || '')) return flavours[i]; }
    for (i = 0; i < flavours.length; i++) { if ((flavours[i].size || '') === (size || '')) return flavours[i]; }
    return flavours[0];
  }
  function nearestPlan(plans, week) {
    var keys = Object.keys(plans || {}).map(Number).filter(function (n) { return !isNaN(n); });
    if (!keys.length) return null;
    keys.sort(function (a, b) { return Math.abs(a - week) - Math.abs(b - week); });
    return plans[String(keys[0])];
  }

  /* ---- trust badges (honest: only what we can stand behind) ---- */
  function badgesFor(handle) {
    var p = PRODUCTS[handle] || {}, tags = p.tags || [], out = [];
    out.push({ t: 'In date', k: 'trust' });
    out.push({ t: 'Sealed by the brand', k: 'trust' });
    if (state.answers.training === 'athlete') {
      var cert = !isAccessory(p) && (tags.some(function (t) { return t.indexOf('cert:') === 0; }) || p.tested);
      out.push(cert ? { t: 'Tested for sport', k: 'trust' } : { t: 'Trusted brand', k: 'trust' });
    }
    if (answerHas('barrier', 'sweet')) out.push({ t: 'Easy to drink', k: 'plain' });
    if (answerHas('barrier', 'price')) out.push({ t: 'Great value', k: 'plain' });
    if (p.sellingPlanId && state.answers.commitment === 'ongoing') out.push({ t: 'Subscribe & save', k: 'sub' });
    return out;
  }
  function whyList(r) {
    var w = [], gl = (CONFIG.goalLabel || {})[r.goal] || 'your goal';
    w.push('Matched to your goal: ' + gl + '.');
    if (answerHas('diet', 'plant')) w.push('Dairy-free, because you train plant-based.');
    else if (answerHas('diet', 'lactose') || answerHas('barrier', 'bloat')) w.push('A gut-friendly pick, chosen to settle the bloating you flagged.');
    if (answerHas('diet', 'noart')) w.push('No artificial sweeteners, the way you like it.');
    if (state.answers.training === 'athlete') w.push('A brand you can stand behind if you get drug-tested.');
    if (answerHas('barrier', 'sweet')) w.push('Picked to be easy to drink, so the tub actually gets finished.');
    if (answerHas('barrier', 'results')) w.push('A simple, proven stack, so you can tell it is doing something.');
    if (answerHas('barrier', 'trust')) w.push('In date and sealed by the brand, never repacked.');
    if (answerHas('barrier', 'price')) w.push('A sharp price per serve for this goal.');
    if (answerHas('barrier', 'unsure')) w.push('No more guessing which tub, this one is matched to your goal.');
    if (state.answers.commitment === 'ongoing') {
      var subAvail = CARDS.some(function (st) { return st.plans && Object.keys(st.plans).length > 0; });
      w.push(subAvail ? 'Set to restock on subscribe and save, so you never run out.' : 'Easy to reorder in a couple of taps whenever you run low.');
    }
    return w;
  }

  /* ---- results ---- */
  function renderResults() {
    backBtn.hidden = false;
    CARDS = [];
    var r = score();
    stage.textContent = '';

    if (!r || !r.hero) {
      var msg = document.createElement('div');
      msg.className = 'nzsq-result';
      msg.innerHTML = '<h2 class="nzsq-q__title">We are still stocking your exact match.</h2>' +
        '<p class="nzsq-lede">Your pick is not live yet. Browse the full range in the meantime, or talk to us and we will sort you out.</p>' +
        '<div class="nzsq-result__cta"><a class="nzsq-btn nzsq-btn--primary" href="/collections/all">Shop all products</a>' +
        '<a class="nzsq-btn nzsq-btn--ghost" href="/pages/contact">Talk to a human</a></div>';
      stage.appendChild(msg);
      return;
    }

    var hero = PRODUCTS[r.hero], support = r.support ? PRODUCTS[r.support] : null, addon = r.addon ? PRODUCTS[r.addon] : null;
    var copy = CONFIG.copy || {}, headline = (CONFIG.goalHeadline || {})[r.goal] || 'your goal';
    var root = document.createElement('div'); root.className = 'nzsq-result';

    var head = document.createElement('div'); head.className = 'nzsq-result__head';
    var bl = badgesFor(r.hero).map(function (b) { return '<span class="nzsq-badge nzsq-badge--' + b.k + '">' + esc(b.t) + '</span>'; }).join('');
    head.innerHTML = '<p class="nzsq-result__eyebrow">Your match</p>' +
      '<h2 class="nzsq-result__title">Built for ' + esc(headline) + '.</h2>' +
      '<div class="nzsq-badges">' + bl + '</div>';
    root.appendChild(head);
    if (answerHas('format', 'rtd')) {
      var rtdPicks = [hero, support, addon].filter(Boolean);
      if (rtdPicks.length && !rtdPicks.some(function (x) { return x.rtd; })) {
        var rtdNote = document.createElement('p'); rtdNote.className = 'nzsq-rtd-note';
        rtdNote.innerHTML = '<b>No ready-to-drink option for this goal yet.</b> Here are the next best picks for what you are training for.';
        root.appendChild(rtdNote);
      }
    }

    /* NZS-FYSFIX 2026-07-12: honest note for drug-tested athletes when no in-stock pick is batch-tested (mirrors the no-RTD note guard) */
    if (state.answers.training === 'athlete') {
      var testedPicks = [hero, support, addon].filter(Boolean);
      if (testedPicks.length && !testedPicks.some(function (x) { return x.tested === true; })) {
        var testedNote = document.createElement('p'); testedNote.className = 'nzsq-rtd-note nzsq-tested-note';
        testedNote.textContent = 'No batch-tested option in stock for part of this stack right now. These are the next best picks, and the tested versions come back regularly.';
        root.appendChild(testedNote);
      }
    }

    var stackEl = document.createElement('div'); stackEl.className = 'nzsq-stack';
    stackEl.appendChild(card(hero, r.hero, 'Hero pick', copy));
    if (support) stackEl.appendChild(card(support, r.support, 'Completes the stack', copy));
    if (addon) stackEl.appendChild(card(addon, r.addon, 'Handy add-on', copy));
    root.appendChild(stackEl);

    var why = document.createElement('ul'); why.className = 'nzsq-why';
    whyList(r).forEach(function (t) { var li = document.createElement('li'); li.textContent = t; why.appendChild(li); });
    root.appendChild(why);

    root.appendChild(buyBlock(r));

    var re = document.createElement('p'); re.className = 'nzsq-reassure';
    re.textContent = CONFIG.reassurance || '';
    root.appendChild(re);
    stage.appendChild(root);
    var anyPlan = CARDS.some(function (st) { return st.plans && Object.keys(st.plans).length > 0; });
    applyMode((anyPlan && state.answers.commitment === 'ongoing') ? 'subscribe' : 'onetime');
  }

  function card(p, handle, tag, copy) {
    var node = TPL.card.content.cloneNode(true);
    var art = node.querySelector('.nzsq-card');
    node.querySelector('[data-tag]').textContent = tag;
    var ml = node.querySelector('[data-link]'); if (ml) ml.href = p.url || '#';
    var nl = node.querySelector('[data-name-link]'); if (nl) nl.href = p.url || '#';
    node.querySelector('[data-benefit]').textContent = (copy[handle] && copy[handle].benefit) || '';
    var testedEl = node.querySelector('[data-tested]'); if (testedEl && p.tested && !isAccessory(p)) testedEl.hidden = false;
    var cb = node.querySelector('[data-select]'); if (cb) cb.setAttribute('data-handle', handle);

    var flavours = Array.isArray(p.flavours) ? p.flavours : [];
    /* NZS-SPD-0808: a custom.fys_flavours snapshot that holds no entry for its OWN product is not
       describing this product, so it must not price it. Measured 2026-08-08: the MusclePharm
       4-pack's snapshot contained the five SINGLE bars, defaultEntry() missed on vid, fell through
       to firstAvail() and rendered $4.70 for a $17.90 product (ghost-energy 12-packs, same shape).
       Dropping the untrustworthy roster falls the card back to its live base price with no flavour
       dropdown; scripts\regen_snapshots.py restores the dropdown by adding the missing entry. */
    if (flavours.length && !selfEntry(flavours, p)) flavours = [];
    var st = { handle: handle, art: art, base: p, flavours: flavours, sel: null, entry: null, week: 6, weekTouched: false };
    var idx = CARDS.push(st) - 1; art.setAttribute('data-idx', idx);

    var initEntry;
    if (flavours.length) {
      var self = selfEntry(flavours, p);
      var def = self || defaultEntry(flavours, p.id);
      /* Sold-out default -> swap to an available sibling of the SAME size (never cross a size
         boundary: a family legitimately spans singles and multipacks).
         The base product's stock is read LIVE, never from the snapshot — Ghost Whey's snapshot
         flags its own in-stock flavour (93 units) as available:false, and trusting that would
         swap the card off its own live-priced product and straight back onto a stale sibling. */
      var defSoldOut = (def === self) ? (p.available === false) : (def && def.available === false);
      if (defSoldOut) {
        var sameSize = flavours.filter(function (f) { return (f.size || '') === (def.size || ''); });
        def = firstAvail(sameSize) || firstAvail(flavours) || def;
      }
      st.sel = { flavour: (def.flavour || ''), size: (def.size || '') };
      buildSelects(st);
      /* live title for the base product; the snapshot's copy can be a rename behind. */
      node.querySelector('[data-name]').textContent =
        familyName(def === selfEntry(flavours, p) ? p.title : (def.title || p.title));
      initEntry = def;
    } else {
      node.querySelector('[data-name]').textContent = p.title;
      initEntry = { vid: p.id, price: p.priceCents, priceMoney: p.price, compareAt: p.compareAt, servings: p.servings, plans: p.plans || {}, image: p.image, available: p.available };
    }
    applyEntry(st, initEntry);
    var _fr = art.querySelector('[data-card-freqrange]'), _fv = art.querySelector('[data-card-freqval]');
    if (_fr) _fr.addEventListener('input', function () { st.week = parseInt(_fr.value, 10) || 6; st.weekTouched = true; if (_fv) _fv.textContent = st.week + ' weeks'; });
    return node;
  }

  function buildSelects(st) {
    var art = st.art, flavours = st.flavours, sel = st.sel;
    var optsWrap = art.querySelector('[data-opts]');
    var fWrap = art.querySelector('[data-flavour-wrap]'), sWrap = art.querySelector('[data-size-wrap]');
    var fSel = art.querySelector('[data-flavour]'), sSel = art.querySelector('[data-size]');
    if (!fSel || !sSel) return;
    var colourOpt = isAccessory(st.base);
    var fLab = art.querySelector('[data-flavour-wrap] .nzsq-card__opt-lab');
    if (fLab) fLab.textContent = colourOpt ? 'Colour' : 'Flavour';
    fSel.setAttribute('aria-label', colourOpt ? 'Colour' : 'Flavour');
    var flavs = flavoursForSize(flavours, sel.size);
    var sizes = distinctSizes(flavours);
    fSel.innerHTML = flavs.map(function (fl) {
      var ent = pickEntry(flavours, fl, sel.size);
      var dis = ent && ent.available === false ? ' disabled' : '';
      return '<option value="' + esc(fl) + '"' + (fl === sel.flavour ? ' selected' : '') + dis + '>' + esc(flavLabel(fl)) + '</option>';
    }).join('');
    sSel.innerHTML = sizes.map(function (sz) {
      return '<option value="' + esc(sz) + '"' + (sz === sel.size ? ' selected' : '') + '>' + esc(sizeLabel(sz)) + '</option>';
    }).join('');
    var showF = flavs.length > 1, showS = sizes.length > 1;
    fWrap.hidden = !showF; sWrap.hidden = !showS;
    optsWrap.hidden = !(showF || showS);
  }

  function applyEntry(st, entry) {
    st.entry = entry;
    var art = st.art, b = st.base;
    /* NZS-SPD-0808 live-first. The base product's price, compare-at, availability and servings are
       rendered LIVE by nzs-quiz-funnel.liquid into the very same JSON blob that carries the frozen
       custom.fys_flavours roster — so for the card's own product the snapshot is never consulted.
       Measured 2026-08-08: Ghost Whey's snapshot said 10495 with no compare-at while live was
       9490 / 11795, i.e. the snapshot both overcharged and hid a real markdown. */
    var isBase = st.flavours.length ? entry === selfEntry(st.flavours, b) : true;
    var img = art.querySelector('[data-img]');
    var imgSrc = isBase ? (b.image || entry.image) : entry.image;
    if (img && imgSrc) { img.src = imgSrc; img.alt = familyName(isBase ? b.title : (entry.title || b.title)); }

    var cents, pm, comp, avail, servings;
    if (isBase) {
      cents = b.priceCents;
      pm = b.price || fmtCents(cents);
      comp = b.compareAt || '';                       // already a formatted money string
      avail = b.available !== false;
      servings = b.servings;
    } else {
      cents = entry.price != null ? entry.price : b.priceCents;
      pm = entry.priceMoney || fmtCents(cents);
      var compCents = Number(entry.compare_at_price || entry.c || 0);
      comp = entry.compareAt || (compCents > cents ? fmtCents(compCents) : '');
      avail = entry.available !== false;
      servings = entry.servings;
    }
    art.setAttribute('data-cents', cents != null ? cents : '');
    art.setAttribute('data-oprice', pm);
    art.setAttribute('data-ocompare', comp);
    art.setAttribute('data-avail', avail ? '1' : '0');
    /* Unavailable pick -> mark it and take it out of the stack. No new UI: the existing sold-out
       styling hook plus an unchecked, disabled include-checkbox (selectedItems() also re-checks
       data-avail, so a live-resolve landing after selection cannot smuggle it into the cart). */
    art.classList.toggle('is-soldout', !avail);
    var selCb = art.querySelector('[data-select]');
    if (selCb) { selCb.disabled = !avail; if (!avail) selCb.checked = false; }
    /* Selling plans follow the same live-first rule: for the base product they come from the
       rendered blob, not the snapshot's `plans` copy. st.plans is the single source every
       subscribe check and the cart payload read, so eligibility can never disagree with price. */
    st.plans = (isBase ? b.plans : entry.plans) || {};
    var hasPlans = Object.keys(st.plans).length > 0;
    art.setAttribute('data-sub', hasPlans ? '1' : '0');
    if (!st.weekTouched) { var _srv = servings || 0; st.week = _srv > 0 ? Math.min(16, Math.max(4, Math.round(_srv / 7))) : 6; }
    var _cfr = art.querySelector('[data-card-freqrange]'), _cfv = art.querySelector('[data-card-freqval]');
    if (_cfr) _cfr.value = st.week; if (_cfv) _cfv.textContent = st.week + ' weeks';
    /* The variant that actually goes in the cart. For the base product that is the LIVE variant id
       from the blob — a snapshot `vid` can point at a variant that has since been recreated. */
    var useVid = isBase ? b.id : entry.vid;
    art.setAttribute('data-vid', useVid != null ? useVid : '');
    var serveEl = art.querySelector('[data-serve]');
    if (serveEl) {
      var line = serveLine(cents, servings);
      if (line) { serveEl.innerHTML = line; serveEl.hidden = false; } else { serveEl.hidden = true; }
    }

    /* A picked SIBLING is verified against Shopify once its handle exists (post-regen). Until then
       entry.handle is undefined and liveResolve() is a no-op, so behaviour is unchanged. */
    if (!isBase && entry.handle && !entry._live) {
      liveResolve(entry.handle, function (L) {
        if (entry._live) return;
        entry._live = 1;
        entry.price = L.price;
        entry.compare_at_price = L.compare_at_price;
        entry.available = L.available;
        if (L.vid) entry.vid = L.vid;
        if (st.entry !== entry) return;               // shopper already moved on
        applyEntry(st, entry);
        applyMode(currentMode);
      });
    }
  }

  /* selector change (flavour / size) -> swap variant, image, price, per-serve */
  stage.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || (!t.hasAttribute('data-flavour') && !t.hasAttribute('data-size'))) return;
    var art = t.closest('.nzsq-card'); if (!art) return;
    var st = CARDS[+art.getAttribute('data-idx')]; if (!st || !st.flavours.length) return;
    if (t.hasAttribute('data-size')) {
      st.sel.size = t.value;
      var flavs = flavoursForSize(st.flavours, st.sel.size);
      if (flavs.indexOf(st.sel.flavour) === -1) st.sel.flavour = flavs[0] || '';
    } else {
      st.sel.flavour = t.value;
      var sizes = sizesForFlavour(st.flavours, st.sel.flavour);
      if (sizes.indexOf(st.sel.size) === -1) st.sel.size = sizes[0] || '';
    }
    buildSelects(st);
    applyEntry(st, pickEntry(st.flavours, st.sel.flavour, st.sel.size));
    applyMode(currentMode);
  });

  /* ---- subscribe pricing + per-item note (NZS) ---- */
  var SUB_PCT = 10; /* conservative strike; stack-category products actually subscribe at 15% */
  function subPrice(cents) { return '$' + (Math.round(cents * (100 - SUB_PCT) / 100) / 100).toFixed(2); }
  function applyMode(mode) {
    currentMode = mode;
    stage.querySelectorAll('.nzsq-card').forEach(function (art) {
      var priceEl = art.querySelector('[data-price]'), noteEl = art.querySelector('[data-subnote]');
      if (!priceEl) return;
      var elig = art.getAttribute('data-sub') === '1', cents = parseInt(art.getAttribute('data-cents'), 10);
      var oprice = art.getAttribute('data-oprice') || '', ocomp = art.getAttribute('data-ocompare') || '';
      var plain = ocomp ? '<s>' + esc(ocomp) + '</s> ' + esc(oprice) : esc(oprice);
      if (mode === 'subscribe' && elig && cents) {
        priceEl.innerHTML = '<s>' + esc(oprice) + '</s> <b class="nzsq-card__subprice">' + esc(subPrice(cents)) + '</b>';
        if (noteEl) { noteEl.hidden = true; noteEl.removeAttribute('data-kind'); }
      } else if (mode === 'subscribe' && !elig) {
        priceEl.innerHTML = plain;
        if (noteEl) { noteEl.textContent = 'One-time only; not included in the subscription'; noteEl.hidden = false; noteEl.setAttribute('data-kind', 'once'); }
      } else {
        priceEl.innerHTML = plain;
        if (noteEl) { noteEl.hidden = true; noteEl.removeAttribute('data-kind'); }
      }
      var _cf = art.querySelector('[data-card-freq]');
      if (_cf) _cf.hidden = !(mode === 'subscribe' && art.getAttribute('data-sub') === '1');
    });
  }

  /* ---- buy block ---- */
  function selectedItems() {
    var items = [];
    CARDS.forEach(function (st) {
      var cb = st.art.querySelector('[data-select]');
      if (!cb || !cb.checked) return;
      var e = st.entry; if (!e) return;
      /* NZS-SPD-0808: cart off data-vid (applyEntry's live-first choice), not the snapshot's vid;
         and never add a pick we know is unavailable. */
      if (st.art.getAttribute('data-avail') === '0') return;
      var vid = st.art.getAttribute('data-vid'); if (!vid) return;
      var item = { id: vid, quantity: 1 };
      var plans = st.plans || e.plans;
      if (currentMode === 'subscribe' && plans && Object.keys(plans).length) {
        var pid = plans[String(st.week)] || nearestPlan(plans, st.week);
        if (pid) item.selling_plan = pid;
      }
      items.push(item);
    });
    return items;
  }
  function buyBlock(r) {
    var box = document.createElement('div'); box.className = 'nzsq-buy';
    var anyPlan = CARDS.some(function (st) { return st.plans && Object.keys(st.plans).length > 0; });
    currentMode = (anyPlan && state.answers.commitment === 'ongoing') ? 'subscribe' : 'onetime';
    var toggle = document.createElement('div'); toggle.className = 'nzsq-toggle';
    toggle.appendChild(toggleOpt('onetime', 'One-time', CONFIG.onetimeNote || 'Pay once', currentMode, true));
    toggle.appendChild(toggleOpt('subscribe', CONFIG.subscribeLabel || 'Subscribe & save', anyPlan ? (CONFIG.subscribeNote || 'Subscribe & save, cancel anytime') : (CONFIG.subscribeSoon || 'Subscribe & save when it launches'), currentMode, anyPlan));
    toggle.addEventListener('click', function (e) {
      var opt = e.target.closest('.nzsq-toggle__opt'); if (!opt || opt.getAttribute('data-disabled')) return;
      var mode = opt.getAttribute('data-mode');
      toggle.querySelectorAll('.nzsq-toggle__opt').forEach(function (o) { o.setAttribute('data-active', o.getAttribute('data-mode') === mode); });
      applyMode(mode);
    });
    box.appendChild(toggle);

    /* per-product delivery cadence sliders now live inside each card (data-card-freq) */

    var ctas = document.createElement('div'); ctas.className = 'nzsq-buy__cta';
    var addBtn = btn('primary', 'Add my stack to cart');
    addBtn.addEventListener('click', function () {
      var items = selectedItems();
      if (!items.length) { feedback(box.querySelector('[data-nzsq-feedback]'), 'Tick at least one item to add.', true); return; }
      addToCart(items, addBtn);
    });
    ctas.appendChild(addBtn);
    box.appendChild(ctas);
    var fb = document.createElement('p'); fb.className = 'nzsq-feedback'; fb.setAttribute('data-nzsq-feedback', ''); fb.setAttribute('aria-live', 'polite');
    box.appendChild(fb);
    return box;
  }
  function toggleOpt(modeId, label, note, active, enabled) {
    var el = document.createElement('label'); el.className = 'nzsq-toggle__opt';
    el.setAttribute('data-mode', modeId); el.setAttribute('data-active', modeId === active);
    if (!enabled) el.setAttribute('data-disabled', 'true');
    el.innerHTML = '<input type="radio" name="nzsq-buymode" value="' + modeId + '"' + (enabled ? '' : ' disabled') + '>' +
      '<strong>' + esc(label) + (enabled ? '' : ' <span class="nzsq-soon">Soon</span>') + '</strong><span>' + esc(note) + '</span>';
    return el;
  }
  function buildFreq() {
    var wrap = document.createElement('div'); wrap.className = 'nzsq-freq';
    wrap.innerHTML =
      '<div class="nzsq-freq__top"><span class="nzsq-freq__lab">Deliver every</span><span class="nzsq-freq__val" data-freqval>' + selectedWeek + ' weeks</span></div>' +
      '<input type="range" class="nzsq-freq__range" data-freqrange min="4" max="16" step="1" value="' + selectedWeek + '" aria-label="Weeks between deliveries">' +
      '<p class="nzsq-freq__help">Pick the gap that matches how fast you get through it. Change or cancel anytime.</p>';
    var range = wrap.querySelector('[data-freqrange]'), val = wrap.querySelector('[data-freqval]');
    range.addEventListener('input', function () {
      selectedWeek = parseInt(range.value, 10) || 6;
      val.textContent = selectedWeek + ' weeks';
    });
    return wrap;
  }
  function addToCart(items, triggerBtn) {
    var fb = stage.querySelector('[data-nzsq-feedback]');
    if (!items.length) { feedback(fb, 'Nothing to add right now.', true); return; }
    triggerBtn.disabled = true; feedback(fb, 'Adding to your cart...', false);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { if (!res.ok) throw new Error('cart'); delCookie(COOKIE); window.location.href = '/cart'; })
      .catch(function () { triggerBtn.disabled = false; feedback(fb, 'Something went wrong. Please try again.', true); });
  }
  function feedback(el, msg, isErr) { if (!el) return; el.textContent = msg; el.setAttribute('data-state', isErr ? 'error' : 'ok'); }

  /* ---- helpers ---- */
  function btn(kind, label) { var b = document.createElement('button'); b.type = 'button'; b.className = 'nzsq-btn nzsq-btn--' + kind; b.textContent = label; return b; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* ---- wire up ---- */
  document.querySelectorAll('[data-nzsq-start]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); open(el.getAttribute('data-nzsq-goal') || null); });
  });
  if (backBtn) backBtn.addEventListener('click', back);
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !app.hidden) close(); });
})();
